import Modal from "@/components/common/ui/modal";
import { IOrganization } from "@/types/organization";
import { ISite } from "@shared/common/types/site";
import React, { useCallback, useEffect, useState } from "react";
import SixshopProOnboardingGuide from "./onboarding/sixshop-pro-onboarding-guide";

interface ISixshopProOnboardingModalProps {
  organizations: IOrganization[];
  currentSite: ISite | null;
  currentOrganization: IOrganization;
  onComplete: () => Promise<void>;
  showOnboarding: boolean;
}

const SixshopProOnboardingModal: React.FC<ISixshopProOnboardingModalProps> = ({
  currentOrganization,
  onComplete,
  showOnboarding,
}) => {
  const [open, setOpen] = useState(showOnboarding);

  const handleClose = useCallback(async () => {
    await onComplete();
    setOpen(false);
  }, [onComplete]);

  useEffect(() => {
    if (currentOrganization.onboardStep === 100) {
      setOpen(false);
    } else {
      setOpen(showOnboarding);
    }
  }, [currentOrganization, showOnboarding]);

  return (
    <Modal
      open={open}
      title="코드앤버터를 사용할 준비가 끝났어요!"
      backdrop
      hideCloseButton
      hideFooter
    >
      <SixshopProOnboardingGuide
        currentOrganization={currentOrganization}
        setStep={() => null}
        onClose={handleClose}
      />
    </Modal>
  );
};

export default SixshopProOnboardingModal;
